import {useWatch} from 'react-hook-form'

import {InputControlled, InputControlledType} from './Input'

type PhoneInputControlledType = Omit<InputControlledType, 'mask'> & {
  /**
   * Функция получения маски телефона
   */
  getPhoneMask?: (value?: string, defaultMask?: string) => string
}

export const PhoneInputControlled = ({getPhoneMask, ...props}: PhoneInputControlledType): React.ReactElement => {
  const phone = useWatch({name: props.name})

  return <InputControlled {...props} mask={getPhoneMask?.(phone)} />
}
